/**
 * 展示alert信息，公共组件
 */
import Decorate from '@tencent/spaui-decorate'
import Dialog from '@tencent/spaui-dialog'

export const dialog = new Decorate(Dialog)

export const showAlert = (type, msg, time = 3000) => {
    dialog.setProps({
        show: true,
        className: 'spaui-dailog-tip-without-bg',
        time,
        timeCallback: () => {
            dialog.setProps({
                show: false,
            })
        },
        type: 'tip',
        iconType: type,
        children: msg,
    })
}

export default showAlert
